module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCA3Ij48dGl0bGU+TlBNIExvZ288L3RpdGxlPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTh2Nkg5djFINVY2SDBWMHptMSA1aDJWMmgxdjNoMVYxSDF2NHptNS00djVoMlY1aDJWMUg2em0yIDFoMXYySDhWMnptMy0xdjRoMlYyaDF2M2gxVjJoMXYzaDFWMWgtNnoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ../static/img/svg-icons/npm.svg
// module id = 416
// module chunks = 0